import { Component } from '@angular/core';

@Component({
  selector: 'app-button-divider',
  templateUrl: './button-divider.component.html',
  styleUrls: ['./button-divider.component.scss'],
  standalone: false
})
export class ButtonDividerComponent { }
